import { render, staticRenderFns } from "./RsaConfigurazioneMenuPazienteListComponent.vue?vue&type=template&id=6af0d0f2"
import script from "./RsaConfigurazioneMenuPazienteListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneMenuPazienteListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports